'use client';
import { FC, PropsWithChildren, useMemo } from 'react';
import { format } from 'date-fns/format';
import { addMonths } from 'date-fns/addMonths';
import { RequestServiceMonthDropdownProps } from '../../types';
import { CatDropdown } from '@blocks-react/components/Dropdown';
import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import { useController, useFormContext } from 'react-hook-form';
import { BlocksSelectEvent } from '@blocks-web-components/events';

export const RequestServiceMonthDropdown: FC<
  PropsWithChildren<RequestServiceMonthDropdownProps>
> = ({ name, handleSelect, setWeekStartDate, size = 'sm' }) => {
  const { control, getValues, setValue } = useFormContext();
  const { field } = useController({ name, control });

  const startDate = getValues(name);

  const getNextTwelveMonths = useMemo(() => {
    const currentDate = new Date();
    const monthsArray = [];

    for (let i = 0; i < 12; i++) {
      const nextMonth = addMonths(currentDate, i);
      monthsArray.push({
        label: format(nextMonth, 'MMMM yyyy'),
        value: format(nextMonth, 'MMMM yyyy')
      });
    }
    return monthsArray;
  }, []);

  const onSelectHandler = (e: BlocksSelectEvent) => {
    field.onChange(e);
    setValue(name, new Date(e.detail.value as string));
    handleSelect(e);
    if (
      new Date().getMonth() === new Date(e.detail.value as string).getMonth()
    ) {
      setWeekStartDate(new Date());
    } else {
      setWeekStartDate(new Date(e.detail.value as string));
    }
  };

  return (
    <CatDropdown
      ariaDescribedBy="selected-month"
      value={format(startDate, 'MMMM yyyy')}
      size={size}
      name={name}
      onBlSelect={(e) => onSelectHandler(e)}
      style={{ minWidth: '200px' }}
    >
      <CatList>
        {getNextTwelveMonths.map((month) => (
          <CatListItem
            data-testid="month-dropdown"
            value={month.value}
            key={month.value}
            style={{ whiteSpace: 'nowrap' }}
          >
            {month.label}
          </CatListItem>
        ))}
      </CatList>
    </CatDropdown>
  );
};
